(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gift-card-balance"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get("gift-card-balance-form")) {
    var GIFT_CARD_BALANCE_ENDPOINT = "/apps/dotapparel/api-checkGiftcardBalance";

    class GiftCardBalanceForm extends HTMLElement {
      connectedCallback() {
        if (this.__bound) return;
        this.__bound = true;

        this.form = this.querySelector("[data-balance-form]");
        this.resultEl = this.querySelector("[data-balance-result]");
        this.errorEl = this.querySelector("[data-balance-error]");
        this.expiredEl = this.querySelector("[data-expired-notice]");
        if (!this.form) return;

        this.submitButton = this.form.querySelector('button[type="submit"]');
        this.inputs = Array.prototype.slice.call(this.form.querySelectorAll("input"));
        this.strings = window.__giftCardBalanceStrings || {};
        this.pending = false;

        this.onSubmit = this.onSubmit.bind(this);
        this.form.addEventListener("submit", this.onSubmit);
      }

      disconnectedCallback() {
        if (this.form) this.form.removeEventListener("submit", this.onSubmit);
        this.__bound = false;
      }

      get numberInput() {
        return this.form.querySelector('[name="gift_card_number"]');
      }

      get pinInput() {
        return this.form.querySelector('[name="gift_card_pin"]');
      }

      onSubmit(event) {
        event.preventDefault();
        // One owner per trigger: ignore re-entry while a request is in flight.
        if (this.pending) return;

        var number = (this.numberInput.value || "").trim();
        var pin = (this.pinInput.value || "").trim();

        if (!number || !pin) {
          this.showError(this.strings.errorRequired);
          return;
        }

        this.setPending(true);
        this.clearPanels();

        var self = this;
        fetch(GIFT_CARD_BALANCE_ENDPOINT, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ number: number, pin: pin })
        })
          .then(function (response) {
            return response
              .json()
              .catch(function () {
                return null;
              })
              .then(function (payload) {
                // The endpoint's success and error shapes differ and carry no
                // success flag, so gate on the status AND a usable data object.
                if (!response.ok || !payload || !payload.data) {
                  throw new Error("balance-lookup-failed");
                }
                return payload.data;
              });
          })
          .then(function (data) {
            self.showResult(number, data);
          })
          .catch(function () {
            self.showError(self.strings.errorGeneric);
          })
          .then(function () {
            self.setPending(false);
          });
      }

      setPending(isPending) {
        this.pending = isPending;
        if (this.submitButton) {
          this.submitButton.disabled = isPending;
          this.submitButton.setAttribute("aria-busy", isPending ? "true" : "false");
          this.submitButton.classList.toggle("loading", isPending);
        }
        this.inputs.forEach(function (input) {
          input.disabled = isPending;
        });
      }

      clearPanels() {
        if (this.resultEl) this.resultEl.hidden = true;
        if (this.errorEl) {
          this.errorEl.hidden = true;
          this.errorEl.textContent = "";
        }
        if (this.expiredEl) {
          this.expiredEl.hidden = true;
          this.expiredEl.textContent = "";
        }
      }

      showError(message) {
        this.clearPanels();
        if (!this.errorEl) return;
        this.errorEl.textContent = message || "";
        this.errorEl.hidden = false;
      }

      showResult(number, data) {
        this.clearPanels();
        if (!this.resultEl) return;

        this.setRow("[data-row-number]", this.strings.rowNumber, number);
        this.setRow("[data-row-expiry]", this.strings.rowExpiry, data.expiryDate);
        this.setRow("[data-row-original]", this.strings.rowOriginal, this.money(data.originalAmount));
        this.setRow("[data-row-used]", this.strings.rowUsed, this.money(data.usedAmount));
        this.setRow("[data-row-balance]", this.strings.rowBalance, this.money(data.availableAmount));

        // Only flag expiry when the date parses unambiguously. A DD/MM/YY string
        // is engine-dependent, so an unparseable date never hides the balance.
        if (this.expiredEl && this.isExpired(data.expiryDate)) {
          this.expiredEl.textContent = this.strings.expiredNotice || "";
          this.expiredEl.hidden = false;
        }

        this.resultEl.hidden = false;
      }

      setRow(selector, label, value) {
        var row = this.resultEl.querySelector(selector);
        if (!row) return;
        // textContent, never innerHTML - API values are never parsed as markup.
        if (value === undefined || value === null || value === "") {
          row.textContent = "";
          row.hidden = true;
          return;
        }
        row.hidden = false;
        row.textContent = (label || "") + " " + value;
      }

      isExpired(value) {
        if (!value) return false;
        // ISO-8601 (YYYY-MM-DD) is the only format Date parses consistently.
        if (!/^\d{4}-\d{2}-\d{2}/.test(String(value))) return false;
        var parsed = new Date(value);
        if (isNaN(parsed.getTime())) return false;
        return parsed.getTime() < Date.now();
      }

      money(value) {
        if (value === undefined || value === null || value === "") return "";
        var amount = Number(String(value).replace(/[^0-9.-]/g, ""));
        if (isNaN(amount)) return String(value);
        // Dual-market store: format against the active currency, never a literal $.
        try {
          return new Intl.NumberFormat(this.strings.locale || undefined, {
            style: "currency",
            currency: this.strings.currency || "AUD"
          }).format(amount);
        } catch (e) {
          return amount.toFixed(2);
        }
      }
    }

    customElements.define("gift-card-balance-form", GiftCardBalanceForm);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
	constructor() {
	super();
	}

	connectedCallback() {
		this.header = document.querySelector('.shopify-section-header');
		this.headerWrapper = document.querySelector('.header-wrapper');
		this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
		this.headerBounds = {};
		this.currentScrollTop = 0;
		this.preventReveal = false;
		this.predictiveSearch = this.querySelector('predictive-search');

		this.onScrollHandler = this.onScroll.bind(this);
		this.hideHeaderOnScrollUp = () => this.preventReveal = true;
		//this.throttledScrollHandler = throttle(this.onScrollHandler, 300);

		this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.addEventListener('scroll', this.onScrollHandler, false);

		this.createObserver();
	}

	disconnectedCallback() {
		this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.removeEventListener('scroll', this.onScrollHandler);
	}

	createObserver() {
		let observer = new IntersectionObserver((entries, observer) => {
		this.headerBounds = entries[0].intersectionRect;
		observer.disconnect();
		});

		if (this.header) {
			observer.observe(this.header);
		}
	}

	onScroll() {
	const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

	if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 1) {
		this.header.classList.add('shopify-section-header-sticky','shopify-section-header-always-sticky');
		this.header.style.transform = 'translateY(-100%)';
	};

	if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 2) {
		this.header.style.transition = 'background var(--duration-short)';
		this.header.style.transform = 'translateY(0)';
	};

	if (this.headerIsAlwaysSticky && scrollTop < this.header.offsetHeight) {
		this.header.classList.remove('shopify-section-header-sticky');
		this.header.style.transform = 'translateY(0)';
		this.header.style.transition = 'background var(--duration-short)';
	};

	if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		if (this.preventHide) return;
		requestAnimationFrame(this.hide.bind(this));
		} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		if (!this.preventReveal) {
		requestAnimationFrame(this.reveal.bind(this));
		} else {
			window.clearTimeout(this.isScrolling);

			this.isScrolling = setTimeout(() => {
			this.preventReveal = false;
			}, 66);

			requestAnimationFrame(this.hide.bind(this));
		}
		} else if (scrollTop <= this.headerBounds.top) {
		requestAnimationFrame(this.reset.bind(this));
		}

		this.currentScrollTop = scrollTop;
	}

	hide() {
		if (this.headerIsAlwaysSticky) return;
		if (document.querySelector(".overflow-hidden-tablet")) return;
		this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
		this.closeMenuDisclosure();
	}

	reveal() {
		if (this.headerIsAlwaysSticky) return;
		if (document.querySelector('.entering-section')) {
			this.header.classList.add('shopify-section-header-sticky', 'animate');
			this.header.classList.remove('shopify-section-header-hidden');
		}
		else{
			this.header.classList.add('shopify-section-header-sticky', 'animate');
			this.header.classList.remove('shopify-section-header-hidden');
		}
	}

	reset() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
	}

	closeMenuDisclosure() {
		this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
		if (this.disclosures) {
			this.disclosures.forEach(disclosure => {
				disclosure.close();
			});
		}
		this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
			if (this.disclosureLists) {
				this.disclosureLists.forEach(disclosureList => {
					disclosureList.setAttribute('hidden', true);
				});
			}
		}
	}

	customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jump-list"] && !Shopify.designMode) return;
  try {
    
	/* Click scrolls to the target and the current one stays marked while you read it.
	   Everything degrades: with no JS the hrefs are still real in-page anchors, and
	   the landing offset lives in CSS (scroll-margin-top), not here. */
	(function () {
		if (window.__jumpListBound) {
			return;
		}
		window.__jumpListBound = true;

		var ACTIVE = "jump-list__link--active";

		var reducedMotion = function () {
			return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
		};

		var linksFor = function (list) {
			return Array.prototype.slice.call(list.querySelectorAll(".jump-list__link"));
		};

		var setActive = function (list, link) {
			linksFor(list).forEach(function (other) {
				var on = other === link;
				other.classList.toggle(ACTIVE, on);
				if (on) {
					other.setAttribute("aria-current", "true");
				} else {
					other.removeAttribute("aria-current");
				}
			});
		};

		var init = function (list) {
			if (list.dataset.jumpListBound === "true") {
				return;
			}
			list.dataset.jumpListBound = "true";

			var links = linksFor(list);
			var byTarget = {};

			links.forEach(function (link) {
				var target = document.getElementById(link.dataset.jumpTarget);
				if (target) {
					byTarget[link.dataset.jumpTarget] = { link: link, target: target };
				}

				link.addEventListener("click", function (event) {
					if (!target) {
						return; // let the browser try the plain anchor
					}
					event.preventDefault();
					setActive(list, link);
					if (list.__jumpListLock) {
						list.__jumpListLock();
					}
					target.scrollIntoView({
						behavior: reducedMotion() ? "auto" : "smooth",
						block: "start"
					});
					// Keep the URL shareable without pushing a history entry per click.
					if (window.history && window.history.replaceState) {
						window.history.replaceState(null, "", "#" + link.dataset.jumpTarget);
					}
				});
			});

			// Document order, so "the last one we have scrolled past" below is meaningful
			// regardless of the order the blocks happen to be listed in.
			var pairs = Object.keys(byTarget)
				.map(function (key) {
					return byTarget[key];
				})
				.sort(function (a, b) {
					return (
						a.target.getBoundingClientRect().top +
						window.scrollY -
						(b.target.getBoundingClientRect().top + window.scrollY)
					);
				});

			/* Reading position, worked out from geometry on scroll.
			   The previous attempt asked an IntersectionObserver for the entry with the
			   smallest bounding-rect top. A section scrolled off the top has a NEGATIVE
			   top, so the earliest one always won that comparison and the mark never left
			   the first link no matter what you clicked. What we actually want is the last
			   section whose top edge has passed the line just under the header. */
			var line = function () {
				var header = parseFloat(
					getComputedStyle(document.documentElement).getPropertyValue("--header-height")
				);
				return (isNaN(header) ? 0 : header) + 40;
			};

			var currentPair = function () {
				var edge = line();
				var chosen = null;
				pairs.forEach(function (pair) {
					if (pair.target.getBoundingClientRect().top - edge <= 1) {
						chosen = pair;
					}
				});
				// Above the first target: keep the first link marked rather than none.
				return chosen || pairs[0];
			};

			// A click sets the mark itself, so hold off the scroll pass while the smooth
			// scroll is still running - otherwise the intermediate positions it passes
			// through would flicker the mark on the way to the target.
			var lockedUntil = 0;
			var queued = false;

			var syncFromScroll = function () {
				if (queued) {
					return;
				}
				queued = true;
				requestAnimationFrame(function () {
					queued = false;
					if (Date.now() < lockedUntil || !pairs.length) {
						return;
					}
					var pair = currentPair();
					if (pair) {
						setActive(list, pair.link);
					}
				});
			};

			list.__jumpListLock = function () {
				lockedUntil = Date.now() + 900;
			};

			if (pairs.length) {
				window.addEventListener("scroll", syncFromScroll, { passive: true });
				window.addEventListener("resize", syncFromScroll);
				syncFromScroll();
			}

			// Deep link: /pages/faqs#faq-orders lands with that entry already marked.
			if (window.location.hash) {
				var hashed = byTarget[window.location.hash.slice(1)];
				if (hashed) {
					setActive(list, hashed.link);
				}
			}
		};

		var initAll = function () {
			Array.prototype.slice
				.call(document.querySelectorAll("[data-jump-list]"))
				.forEach(init);
		};

		initAll();
		document.addEventListener("DOMContentLoaded", initAll);
		document.addEventListener("shopify:section:load", initAll);
	})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  //class CartNote extends HTMLElement {
  //  constructor() {
  //    super();

  //    this.addEventListener(
  //      'change',
  //      debounce((event) => {
  //        const body = JSON.stringify({ note: event.target.value });
  //        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
  //      }, 300)
  //    );
  //  }
  //}

  //customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
class ProductModal extends ModalDialog {
	constructor() {
		super();

		this.isProductPage = true
	}

	hide() {
		super.hide(this.isProductPage);
		window.pauseAllMedia();
	}

	show(opener) {
		super.show(opener);
		this.showActiveMedia();		
	}

	showActiveMedia() {
		const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
		if (activeMedia) {
				activeMedia.classList.add('active');
				activeMedia.scrollIntoView();
		}
		if (activeMedia?.nodeName == 'DEFERRED-MEDIA' && activeMedia?.querySelector('template')?.content?.querySelector('.js-youtube'))
			activeMedia.loadContent();
	}
}

customElements.define('product-modal', ProductModal);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["preview-design-system"]) return;
  try {
    
  document.addEventListener("input", function (e) {
    if (e.target.id !== "ds-icon-search") return;
    var q = e.target.value.trim().toLowerCase();
    document.querySelectorAll("#ds-icon-grid .icon-card").forEach(function (card) {
      var name = (card.getAttribute("data-name") || "").toLowerCase();
      card.hidden = q.length > 0 && name.indexOf(q) === -1;
    });
  });
  document.addEventListener("click", function (e) {
    var btn = e.target.closest(".swatch-copy-btn");
    if (!btn) return;
    var val = btn.getAttribute("data-color");
    if (navigator.clipboard) { navigator.clipboard.writeText(val); }
    var prev = btn.textContent; btn.textContent = "Copied"; setTimeout(function () { btn.textContent = prev; }, 1200);
  });
  document.addEventListener("click", function (e) {
    var opener = e.target.closest("[data-ds-drawer-open]");
    if (!opener) return;
    var drawer = document.getElementById(opener.getAttribute("data-ds-drawer-open"));
    if (drawer && typeof drawer.open === "function") drawer.open(opener);
  });

  } catch(e) { console.error(e); }
})();
})();
